import React, {Suspense, memo, useState, useEffect} from 'react'
import _ from '/home/ps/root'
import './index.css'
import Loading from './view/loading'
import Table from './table'
import { cache, getConfig } from '../../global'
import { Toast } from '../master/toast'
// const Book = React.lazy(() => import('./screen/book'))
const Otp = React.lazy(() => import('./screen/otp'))
const Welcome = React.lazy(() => import('./screen/welcome'))
const Ride = React.lazy(() => import('./screen/ride'))
const Parcel = React.lazy(() => import('./screen/parcel'))
const Search = React.lazy(() => import('./screen/search'))
const Stage = React.lazy(() => import('./screen/stage'))
const Driver = React.lazy(() => import('./screen/driver'))
const Deliver = React.lazy(() => import('./screen/deliver'))
const Sponsor = React.lazy(() => import('./screen/sponsor'))
const Paid = React.lazy(() => import('./pay/paid'))
const Edit = React.lazy(() => import('./view/edit'))
const Tab = React.lazy(() => import('./view/tab'))
// import Tab from './view/tab'
const Online = React.lazy(() => import('./view/online'))
export const ID = 'state'
const __State__ = {}
const State = prop => {
  const { park } = prop
  const {wakeLock, okI, /*route, */cpc, opc, lpc, lang, param, uid, vid, emptyStore, verb, vendor, owner, cookie, login, master, u, views} = prop.master
  const db = (u=='store' || _.Q_.includes(u)) ? vid : (_.USER_.includes(u) ? 'user' : uid)
  const pc = `cpc ${cpc},  opc ${opc}, lpc ${lpc}, param ${JSON.stringify(param)}`
  if (window.opener && !lpc) {
    alert(`Child window closing: ${pc}`)
    window.opener.focus()
    window.opener.postMessage(JSON.stringify({ID, 'cmd':'close'}))
    window.close()
  }
  // const url = `https://${cookie[_.HOME]}.${_.DOMAIN}/fec/request.php`// appswhat.com
  // <form action={url} method='post' encType='multipart/form-data' autoComplete={'on'} name={`${ID}${window.opener ? '':'opener'}`}>
  const orient = screen.orientation
  const [state, _setState] = useState({type: orient.type, angle: orient.angle, wakeLock: null})
  // const [state, setState] = useState({type: orient.type, angle: orient.angle, wakeLock: null})
  const {type, angle/*, wakeLock*/} = state
  // const setState = s => _setState({...state, ...s})
  const setState = s => _setState(_s => ({..._s, ...s}))
  // const onOrientation = e => setState({type: e.target.type, angle: e.target.angle})
  orient.onChange = e => setState({type: e.target.type, angle: e.target.angle})
  // let _v = _.CONFIG
  // const cfgP = park?.[_v]?.[vid]?.[_.DEF]
  // const cfgId = cfgP && Object.keys(cfgP)[0]
  // const cfg = cfgP && cfgP[cfgId]
  const cfg = getConfig(park, lang, vid)
  // _v = _.PURCHASE
  const npk = prop.new[vid]?.purchase
  const cart = npk && park?.purchase?.[vid]?.default?.[prop.new[vid].purchase]

  // const v = opc ? _.CONFIG : _.PURCHASE
  // const parked = park && park[v] && park[v][vid] && park[v][vid][_.DEF]
  // const pk = opc ? parked && Object.keys(parked)[0] : prop[_.NEW_][vid] && prop[_.NEW_][vid][v]
  // const rule = cpc ? prop[_.NEW_][vid] : parked
  // const row = rule && parked && parked[pk]// || {}
  // const row = parked && parked[pk]// || {}
  // if (lpc && row.map) debugger
  // if (lpc && row.json) debugger
  // if (lpc) debugger
//   if (!lpc) {
//     const key = cpc ? 'cart' : 'origin'
//     const vcache = cache(`${lang}${db}${v}`)
//     const pub = vcache && vcache[`0${_.PUB}`]
//     const cfg = pub && pub[0]
//     const cached = cfg && cache(`${lang}${db}${v}${cfg}`) || {}
//     const value = cpc ? (row.json && row.json!='[]' ? row : '?') : (row.map || cached.map)
// debugger
//   }
  useEffect(() => {
    // if (route) debugger
    if (lpc) {
      if (window.opener) {
        const key = cpc ? 'cart' : 'origin'
        // const vcache = cache(`${lang}${db}${v}`)
        // const pub = vcache && vcache[`0${_.PUB}`]
        // const cfg = pub && pub[0]
        // const cached = cfg && cache(`${lang}${db}${v}${cfg}`) || {}
        const value = cpc ? (cfg.json && cfg.json!='[]' ? cfg : '?') : '?'
  prop.message({dbg: `key ${key}, value ${value}, ${pc}`})
        const msg = {[key]: value}
        if (cpc) msg.m = param.m
        if (!__State__.cart) {
          __State__.cart = 1
          prop.message(msg)
        }
        console.log('tariq', state, cfg, msg)
      } else {
        if (opc && cfg) prop.setMaster({'origin': {...JSON.parse(cfg.map), title: cfg.title, username: vendor.username, home: vendor.home, id: vendor.id}})
        if (cpc && cart && cart.json!='[]') setTimeout(() => prop.onMessage({data: {cart}}), 3333)
      }
    }
  }, [cfg, cart])

  // }, [document.visibilityState, row.json])
  // }, [cpc ? row.json : row.map, route])
  // })//, [row.json, row.map, route])
  // <div id={ID} onClick={e => {
  //   e.preventDefault()
  //   e.stopPropagation()
  //   prop.master.slide(_.LOGO, _.HIDE)
  // }}>
  return emptyStore ? <div className='center theme h1'>{master.empty.i}</div> : (
    <div id={ID}>
      <div>angle: {angle}</div>
      <div>type: {type}</div>
      <div>name: {window.opener ? 'child':'parent'}</div>
      <div>screen saver: {wakeLock ? 'off':'on'}</div>
      {
        /*
        <input
          type='button'
          disabled={!('wakeLock' in navigator)}
          value={'Screen saver: ' + (wakeLock ? 'off':'on')}
          onClick={e => {
            if (wakeLock) wakeLock.release().then(() => setState({wakeLock: null}))
            else lockWake()
          }}
        />
        */
      }
      <form encType='multipart/form-data' name={`${ID}${window.opener ? 'child':'parent'}`}>
        <Suspense fallback={<Loading/>}>
        {u=='store' && <Tab { ...prop } db = { db } ID = { ID }/>}
        {
          views.reduce((accv, v, i) => {
            const key = `${ u }${ v }`
            const p = {
              ...prop,
              v,
              ID,
              db,
              pk: _.Q_.includes(u) ? (u==v && owner) : _.MASTER_.includes(v), // hint table to create negative rows or not
              renderMap: v!='page' && v!='ride' && v!='deliver',
              renderLocation: v=='page' || v=='ride' || v=='deliver',

            }
            switch(v) {
              case 'otp':     accv.push(<Otp key = { key } { ...p }/>); break
              case 'welcome': accv.push(<Welcome key = { key } { ...p }/>); break
              case 'ride':    accv.push(<Ride key = { key } { ...p }/>); break
              case 'parcel':  accv.push(<Parcel key = { key } { ...p }/>); break
              case 'search':  accv.push(<Search key = { key } { ...p }/>); break
              case 'stage':   accv.push(<Stage key = { key } { ...p }/>); break
              case 'driver':  accv.push(<Driver key = { key } { ...p }/>); break
              case 'deliver': accv.push(<Deliver key = { key } { ...p }/>); break
              case 'sponsor': accv.push(<Sponsor key = { key } { ...p }/>); break
              // case _.BOOK:    accv.push(<Book { ...p }/>); break
              case 'paid':    accv.push(<Paid key = { key } { ...p }/>); break
              case 'pay':     accv.push(<Pay key = { key } { ...p }/>); break
              case 'edit':    accv.push(<Edit key = { key } { ...p }/>); break
              case 'online':  accv.push(<Online key = { key } { ...p }/>); break
              default:        accv.push(<div key={v} style={{borderBottom: '1px solid #ddd'}}><Table key = { key } { ...p }/></div>)
            }
            return accv
          }, [])
        }
        </Suspense>
      </form>
    </div>
  )
}
State.ID = ID
export default State
// State.propTypes = masterPropType;
